module.exports = __webpack_public_path__ + "img/2019-05-15.f0f22565.jpg";